import React, { Component } from 'react'
import moment from 'moment';
import { CURRENCY, Datos_Empresa, FORMAT_NUMBER, SYMBOL } from "../../libs/utils/Const";
import { NumeroLetra } from '../NewOrder';
import { development } from "../../libs/utils/Const";
class DeliveryHouse extends Component {

    DayName(DocHeader){
        return(
        DocHeader && moment(DocHeader.DocDate).format("dddd") == "Monday"? "Lunes":
        DocHeader && moment(DocHeader.DocDate).format("dddd") == "Tuesday"? "Martes":
        DocHeader && moment(DocHeader.DocDate).format("dddd") == "Wednesday"? "Miercoles":
        DocHeader && moment(DocHeader.DocDate).format("dddd") == "Thursday"? "Jueves":
        DocHeader && moment(DocHeader.DocDate).format("dddd") == "Friday"? "Viernes":
        DocHeader && moment(DocHeader.DocDate).format("dddd") == "Saturday"? "Sabado":
        DocHeader && moment(DocHeader.DocDate).format("dddd") == "Sunday"? "Domingo":
        ""
        );

    }
    MontName(DocHeader){
        return(
            DocHeader && moment(DocHeader.DocDate).format("MM") == "01"? "Enero":
            DocHeader && moment(DocHeader.DocDate).format("MM") == "02"? "Febrero":
            DocHeader && moment(DocHeader.DocDate).format("MM") == "03"? "Marzo":
            DocHeader && moment(DocHeader.DocDate).format("MM") == "04"? "Abril":
            DocHeader && moment(DocHeader.DocDate).format("MM") == "05"? "Mayo":
            DocHeader && moment(DocHeader.DocDate).format("MM") == "06"? "Junio":
            DocHeader && moment(DocHeader.DocDate).format("MM") == "07"? "Julio":
            DocHeader && moment(DocHeader.DocDate).format("MM") == "08"? "Agosto":
            DocHeader && moment(DocHeader.DocDate).format("MM") == "09"? "Septiembre":
            DocHeader && moment(DocHeader.DocDate).format("MM") == "10"? "Octubre":
            DocHeader && moment(DocHeader.DocDate).format("MM") == "11"? "Noviembre":
            DocHeader && moment(DocHeader.DocDate).format("MM") == "12"? "Diciembre":
            ""
        );
    }

    ExtraTable(DocLines, countLines2, linesfullPage, linesfirstPage, countPages, folio, totalPages, subtotal, VatSum, DocTotal, nextFolio){
        
        return(
            
            <table><tr><td>
                <div style={{ height: "auto", width: "85%", marginLeft: "auto", marginRight: "auto", marginTop: "5vw" }}>
                    <div className='text-right mb-4' style={{fontSize:"14px"}}>
                        <table>
                            <tbody>
                                <tr>
                                    <td className='text-left'>
                                        {folio}
                                    </td>
                                    <td className='text-right'>
                                    {nextFolio+" - "}Pagina {countPages+2}/{Math.trunc((DocLines.length - linesfirstPage) / linesfullPage)+2}
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div className='row mt-5' style={{ paddingRight: "15px" }}>
                        <div className='col-12'>
                            <table>
                                <thead style={{ border: "solid 1px" }}>
                                    <tr>
                                        <th className="text-center" style={{ width: "3vw" }}> # </th>
                                        <th>Número de artículo</th>
                                        <th>Descripción</th>
                                        <th>Cantidad</th>
                                        <th className="text-center">UM</th>
                                        <th>Precio</th>
                                        <th>Importe</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {!!DocLines && Array.isArray(DocLines) && DocLines.length > 0 &&
                                        DocLines.map((docLine, index) => {
                                            subtotal=Number(docLine.LineTotal)+subtotal;
                                            if ((countLines2> linesfirstPage + (linesfullPage * countPages)) &&  (countLines2< linesfirstPage + (linesfullPage * (countPages+1)))) {
                                                countLines2++
                                                return (
                                                    <tr style={{ fontSize: '12px' }}>
                                                        <td className="text-center ml-3 mr-3" style={{ border: "solid 1px" }}>{index + 1}</td>
                                                        <td style={{ border: "solid 1px" }}>{docLine.ItemCode ?? ''}</td>
                                                        <td style={{ border: "solid 1px" }}>{docLine.Dscription ?? ''}</td>
                                                        <td className="text-center" style={{ border: "solid 1px" }}>{docLine.OpenQty ?? ''}</td>
                                                        <td style={{ border: "solid 1px" }}>{!!docLine.SalUnitMsr && docLine.SalUnitMsr}</td>
                                                        <td style={{ border: "solid 1px" }}>{CURRENCY + ' ' + FORMAT_NUMBER.new(docLine.Price)}</td>
                                                        <td style={{ border: "solid 1px" }}>{CURRENCY + ' ' + FORMAT_NUMBER.new(docLine.LineTotal)}</td>
                                                    </tr>
                                                );
                                            }else{
                                                countLines2++
                                                return(<></>);
                                            }
                                        })
                                    }
                                    {countPages === totalPages-1 &&
                                        <>
                                            <br/>
                                            <tr>
                                                <td colspan="5"></td>
                                                <td >Subtotal: </td>
                                                <td >{CURRENCY + ' ' + FORMAT_NUMBER.new(subtotal)}</td>
                                            </tr>
                                            <tr>
                                                <td colspan="5"></td>
                                                <td >I.V.A.: </td>
                                                <td >{CURRENCY + ' ' + FORMAT_NUMBER.new(VatSum)}</td>
                                            </tr>
                                            <tr>
                                                <td colspan="5"></td>
                                                <td ><strong>Total: </strong></td>
                                                <td ><strong>{CURRENCY + ' ' + FORMAT_NUMBER.new(DocTotal)}</strong></td>
                                            </tr>
                                        </>
                                    }
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </td></tr></table>
        );
        
    }



    render() {
        const {DocLines, DocHeader, InfoByFolio, reprint, user, time, prioridadVta } = this.props
        
        let linesForAllInOne = 21;
        let linesfirstPage = 39;
        let linesfullPage = 61;

        let remainingLines = (DocLines.length-linesfirstPage) - (linesfullPage * Math.trunc((DocLines.length-linesfirstPage)/linesfullPage));
        let totalPages = Math.ceil( (DocLines.length - linesfirstPage) / linesfullPage );
        let countLines = 1;
        let countLines2 = 1;
        let extraTables = [];
        let subtotal=0;
        
        for (let index = 0; index < totalPages; index++) {
            extraTables.push (this.ExtraTable(DocLines, countLines2, linesfullPage, linesfirstPage, index, InfoByFolio.folio, totalPages, subtotal, DocHeader.VatSum, DocHeader.DocTotal, (!!InfoByFolio.nextFolio && InfoByFolio.nextFolio)))
        }
        
        let totalLetra = '';
        let numeroLetra = new NumeroLetra();
        totalLetra = numeroLetra.NumeroALetras(null, Number(Number(DocHeader.DocTotal).toFixed(2)));
        
        return (
            <>
            {/* Pedidos con 26 o menos articulos */}
                {DocLines.length <= linesForAllInOne &&
                    <table><tr><td>
                        <div>
                            <div style={{ height: "auto", width: "85%", marginLeft: "auto", marginRight: "auto", marginTop: "5vw" }}>
                                <div className='text-right mb-4' style={{ fontSize: "14px" }}>
                                    <table>
                                        <tbody>
                                            <tr>
                                                <td className='text-right'>
                                                    {(!!InfoByFolio.nextFolio && InfoByFolio.nextFolio)}
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                                <div className="row">
                                    <div className="col-3">
                                        <img src={development? require('../../images/logo_draft.svg') : require('../../images/logo_EMPRESA.svg')} alt="Logo" />
                                        <p className="text-center">{Datos_Empresa.Nombre} {Datos_Empresa.Sociedad}<br /><strong>{InfoByFolio ? InfoByFolio.folio : ''}</strong></p>
                                    </div>
                                    <div className="col-6 text-center">
                                        <h4><strong>ENTREGA A DOMICILIO</strong></h4>
                                        <h4>(Por cobrar)</h4>
                                    </div>
                                    <div className="col-3">
                                        <span className="text-left">Sucursal:</span>
                                        <p>{Datos_Empresa.Calle} #{Datos_Empresa.Numero} <br />COL. {Datos_Empresa.Colonia},{Datos_Empresa.Ciudad}, {Datos_Empresa.Estado}. C.P.{Datos_Empresa.CP}</p>
                                    </div>
                                </div>
                                <div className='row mt-5'>
                                    <div className='col-8'>
                                        <span>Fecha del documento: </span>
                                        <span>{DocHeader && moment(DocHeader.DocDate).format("YYYY-MM-DD")}</span><br />
                                        <span>Vendedor: </span>
                                        <span>{DocHeader.SlpCode +" - "+ DocHeader.SlpName}</span><br /><br />
                                        <strong>
                                            <span>Cliente:</span><br />
                                            <span className='ml-3'>{DocHeader && DocHeader.CardCode} - {DocHeader && DocHeader.CardName}</span><br /><br />
                                            <span>Dirección de entrega:</span>
                                            <p className='ml-3'>
                                                {DocHeader && DocHeader.ShipDirection}
                                            </p>
                                            <span>Teléfono: </span>
                                            <span className='ml-3'>{DocHeader.Cellular}</span><br />
                                            <span>Prioridad de entrega: </span>
                                            <span className='ml-3'>{prioridadVta(DocHeader?.U_FMB_PRIORIDADVTA)}</span>
                                        </strong>



                                    </div>
                                    <div className='col-4'>
                                        <table>
                                            <tbody>
                                                <tr>
                                                    <td>Fecha de impresión:</td>
                                                    <td>{moment(new Date()).format("YYYY-MM-DD")}</td>
                                                </tr>
                                                <tr>
                                                    <td>Hora de impresión:</td>
                                                    <td>{moment(new Date()).format("LT")}</td>
                                                </tr>
                                                <tr>
                                                    <td>Folio:</td>
                                                    <td>{InfoByFolio ? InfoByFolio.folio : ''}</td>
                                                </tr>
                                                <tr>
                                                    <td>Hoja:</td>
                                                    <td>1/1</td>
                                                </tr>

                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                                <div className='row mt-5' style={{ paddingRight: "15px" }}>
                                    <div className='col-12'>
                                        <label className="text-center" style={{fontSize: "14px"}}>{reprint?<><strong>REIMPRESION: </strong>{user.U_NAME} {time}</>:""}</label>
                                        <table>
                                            <thead style={{ border: "solid 1px" }}>
                                                <tr>
                                                    <th className="text-center" style={{ width: "3vw" }}> # </th>
                                                    <th>Número de artículo</th>
                                                    <th>Descripción</th>
                                                    <th>Cantidad</th>
                                                    <th className="text-center">UM</th>
                                                    <th>Precio</th>
                                                    <th>Importe</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {!!DocLines && Array.isArray(DocLines) && DocLines.length > 0 &&
                                                    DocLines.map((docLine, index) => {
                                                        subtotal=Number(docLine.LineTotal)+subtotal;
                                                        return (
                                                            <tr style={{ fontSize: '12px' }}>
                                                                <td className="text-center ml-3 mr-3" style={{ border: "solid 1px" }}>{index + 1}</td>
                                                                <td style={{ border: "solid 1px" }}>{docLine.ItemCode ?? ''}</td>
                                                                <td style={{ border: "solid 1px" }}>{docLine.Dscription ?? ''}</td>
                                                                <td className="text-center" style={{ border: "solid 1px" }}>{Number(docLine.Quantity).toFixed(4) ?? ''}</td>
                                                                <td style={{ border: "solid 1px" }}>{!!docLine.SalUnitMsr && docLine.SalUnitMsr}</td>
                                                                <td style={{ border: "solid 1px" }}>{CURRENCY + ' ' + FORMAT_NUMBER.new(docLine.Price)}</td>
                                                                <td style={{ border: "solid 1px" }}>{CURRENCY + ' ' + FORMAT_NUMBER.new(docLine.LineTotal)}</td>
                                                            </tr>
                                                        );
                                                    })
                                                }
                                                <br/>
                                                <tr>
                                                    <td colspan="5"></td>
                                                    <td >Subtotal: </td>
                                                    <td >{CURRENCY + ' ' + FORMAT_NUMBER.new(subtotal)}</td>
                                                </tr>
                                                <tr>
                                                    <td colspan="5"></td>
                                                    <td >I.V.A.: </td>
                                                    <td >{CURRENCY + ' ' + FORMAT_NUMBER.new(DocHeader.VatSum)}</td>
                                                </tr>
                                                <tr>
                                                    <td colspan="5"></td>
                                                    <td ><strong>Total: </strong></td>
                                                    <td ><strong>{CURRENCY + ' ' + FORMAT_NUMBER.new(DocHeader.DocTotal)}</strong></td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                                <div className='row mt-5' style={{ paddingRight: "15px" }}>
                                    <div className='col-12'>
                                        <h6 className='text-center'>CAMBIOS Y DEVOLUCIONES ÚNICAMENTE DENTRO DE LOS PRIMEROS 7 DíAS CON LA NOTA</h6>
                                        <p>Debo(emos) incondicionalmente a la orden de {Datos_Empresa.Name}, en {Datos_Empresa.Ciudad} el día {DocHeader &&  this.DayName(DocHeader)}, {DocHeader && moment(DocHeader.DocDate).format("DD")} de {DocHeader && this.MontName(DocHeader)} {DocHeader && moment(DocHeader.DocDate).format("YYYY")} la cantidad de {CURRENCY + ' ' + FORMAT_NUMBER.new(DocHeader.DocTotal)} ({totalLetra}) Valor recibido a mí (nuestra) entera satisfacción de la mercancía. Este pagaré es mercantil y está regido por la ley General de Títulos y Operaciones de Crédito en su artículo 173 parte final y artículos comelativos, por no ser pagaré domiciliado. Si este pagaré no es liquidado en su fecha de vencimiento , causará interés moratorio al 3% por ciento mensual, nos reservamos el derecho de cobrar el 20% sobre el importe por cheques devueltos.</p>
                                        <br />
                                        <br />
                                        <br />
                                        {InfoByFolio.paidOut == 'N' &&
                                            <br/>
                                        }
                                        <table>
                                            <tbody>
                                                {InfoByFolio.paidOut == 'Y' &&
                                                    <tr>
                                                        <td></td>
                                                        <td></td>
                                                        <td className="text-right">
                                                            <img src={require('../../images/sello.png')} alt="Sello" style={{width:"275px"}}/>
                                                        </td>
                                                    </tr>
                                                }
                                                <tr>
                                                    <td className="text-center" colspan="3">__________________________________________________________</td>
                                                </tr>
                                                <tr>
                                                    <td className="text-center" colspan="3">ACEPTO</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </td></tr></table>
                }
            
            {/* Pedidos con mas de 26 articulos */}
                {DocLines.length > linesForAllInOne&&
                    <>
                    {/* Primera hoja del pedido */}
                        <table><tr><td>
                            <div>
                                <div style={{ height: "auto", width: "85%", marginLeft: "auto", marginRight: "auto", marginTop: "5vw" }}>
                                    <div className='text-right mb-4' style={{fontSize:"14px"}}>{(!!InfoByFolio.nextFolio && InfoByFolio.nextFolio)+" - "}Pagina 1/
                                    {(DocLines.length > linesForAllInOne && linesfirstPage > DocLines.length)?
                                        2
                                    :
                                        totalPages+1
                                    }
                                    </div>
                                    <div className="row">
                                        <div className="col-3">
                                            <img src={development? require('../../images/logo_draft.svg') : require('../../images/logo_EMPRESA.svg')} alt="Logo" />
                                            <p className="text-center">{Datos_Empresa.Nombre} {Datos_Empresa.Sociedad}<br /><strong>{InfoByFolio ? InfoByFolio.folio : ''}</strong></p>
                                        </div>
                                        <div className="col-6 text-center">
                                            <h4><strong>ENTREGA A DOMICILIO</strong></h4>
                                            <h4>(Por cobrar)</h4>
                                        </div>
                                        <div className="col-3">
                                            <span className="text-left">Sucursal:</span>
                                            <p>{Datos_Empresa.Calle} #{Datos_Empresa.Numero} <br />COL. {Datos_Empresa.Colonia},{Datos_Empresa.Ciudad}, {Datos_Empresa.Estado}. C.P.{Datos_Empresa.CP}</p>
                                        </div>
                                    </div>
                                    <div className='row mt-5'>
                                        <div className='col-8'>
                                            <span>Fecha del documento: </span>
                                            <span>{DocHeader && moment(DocHeader.DocDate).format("YYYY-MM-DD")}</span><br />
                                            <span>Chofer: </span>
                                            <span>ARACELY GUTIERREZ MARTINEZ</span><br /><br />
                                            <strong>
                                                <span>Cliente:</span><br />
                                                <span className='ml-3'>CÓDIGO: {DocHeader && DocHeader.CardCode}- {DocHeader && DocHeader.CardName}</span><br /><br />
                                                <span>Dirección de entrega:</span>
                                                <p className='ml-3'>
                                                    {DocHeader && DocHeader.ShipDirection}
                                                </p>
                                                <span>Teléfono: </span>
                                                <span className='ml-3'>555-555-5555</span>
                                            </strong>
                                        </div>
                                        <div className='col-4'>
                                            <table>
                                                <tbody>
                                                    <tr>
                                                        <td>Fecha de impresión:</td>
                                                        <td>{moment(new Date()).format("YYYY-MM-DD")}</td>
                                                    </tr>
                                                    <tr>
                                                        <td>Hora de impresión:</td>
                                                        <td>{moment(new Date()).format("LT")}</td>
                                                    </tr>
                                                    <tr>
                                                        <td>Folio:</td>
                                                        <td>{InfoByFolio ? InfoByFolio.folio : ''}</td>
                                                    </tr>
                                                    <tr>
                                                        <td>Hoja:</td>
                                                        <td>1/{totalPages+1}</td>
                                                    </tr>

                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                    <div className='row mt-5' style={{ paddingRight: "15px" }}>
                                        <div className='col-12'>
                                        <label className="text-center" style={{fontSize: "14px"}}>{reprint?<><strong>REIMPRESION: </strong>{user.U_NAME} {time}</>:""}</label>
                                            <table>
                                                <thead style={{ border: "solid 1px" }}>
                                                    <tr>
                                                        <th className="text-center" style={{ width: "3vw" }}> # </th>
                                                        <th>Número de artículo</th>
                                                        <th>Descripción</th>
                                                        <th>Cantidad</th>
                                                        <th className="text-center">UM</th>
                                                        <th>Precio</th>
                                                        <th>Importe</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {!!DocLines && Array.isArray(DocLines) && DocLines.length > 0 &&
                                                        DocLines.map((docLine, index) => {
                                                            subtotal=Number(docLine.LineTotal)+subtotal;
                                                            if (countLines <= linesfirstPage) {
                                                                countLines++
                                                                return (
                                                                    <tr style={{ fontSize: '12px' }}>
                                                                        <td className="text-center ml-3 mr-3" style={{ border: "solid 1px" }}>{index + 1}</td>
                                                                        <td style={{ border: "solid 1px" }}>{docLine.ItemCode ?? ''}</td>
                                                                        <td style={{ border: "solid 1px" }}>{docLine.Dscription ?? ''}</td>
                                                                        <td className="text-center" style={{ border: "solid 1px" }}>{docLine.OpenQty ?? ''}</td>
                                                                        <td style={{ border: "solid 1px" }}>{!!docLine.SalUnitMsr && docLine.SalUnitMsr}</td>
                                                                        <td style={{ border: "solid 1px" }}>{CURRENCY + ' ' + FORMAT_NUMBER.new(docLine.Price)}</td>
                                                                        <td style={{ border: "solid 1px" }}>{CURRENCY + ' ' + FORMAT_NUMBER.new(docLine.LineTotal)}</td>
                                                                    </tr>
                                                                );
                                                            }else{
                                                                countLines++
                                                                return(<></>);
                                                            }
                                                        })
                                                    }
                                                    {DocLines.length<=linesfirstPage&&
                                                        <>
                                                            <br/>
                                                            <tr>
                                                                <td colspan="5"></td>
                                                                <td >Subtotal: </td>
                                                                <td >{CURRENCY + ' ' + FORMAT_NUMBER.new(subtotal)}</td>
                                                            </tr>
                                                            <tr>
                                                                <td colspan="5"></td>
                                                                <td >I.V.A.: </td>
                                                                <td >{CURRENCY + ' ' + FORMAT_NUMBER.new(DocHeader.VatSum)}</td>
                                                            </tr>
                                                            <tr>
                                                                <td colspan="5"></td>
                                                                <td ><strong>Total: </strong></td>
                                                                <td ><strong>{CURRENCY + ' ' + FORMAT_NUMBER.new(DocHeader.DocTotal)}</strong></td>
                                                            </tr>
                                                        </>
                                                    }
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </td></tr></table>

                    {/* Tablas extra de articulos */}
                        {DocLines.length > linesfirstPage && extraTables}

                    {/* Pagare */}
                        <table><tr><td>
                            <div>
                                <div style={{ height: "auto", width: "85%", marginLeft: "auto", marginRight: "auto", marginTop: "5vw" }}>
                                    <div className='row mt-5' style={{ paddingRight: "15px" }}>
                                        <div className='col-12'>
                                            <h6 className='text-center'>CAMBIOS Y DEVOLUCIONES ÚNICAMENTE DENTRO DE LOS PRIMEROS 7 DíAS CON LA NOTA</h6>
                                            <p>Debo(emos) incondicionalmente a la orden de {Datos_Empresa.Name}, en {Datos_Empresa.Ciudad} el día {DocHeader &&  this.DayName(DocHeader)}, {DocHeader && moment(DocHeader.DocDate).format("DD")} de {DocHeader && this.MontName(DocHeader)} {DocHeader && moment(DocHeader.DocDate).format("YYYY")} la cantidad de {CURRENCY + ' ' + FORMAT_NUMBER.new(DocHeader.DocTotal)} ({totalLetra}) Valor recibido a mí (nuestra) entera satisfacción de la mercancía. Este pagaré es mercantil y está regido por la ley General de Títulos y Operaciones de Crédito en su artículo 173 parte final y artículos comelativos, por no ser pagaré domiciliado. Si este pagaré no es liquidado en su fecha de vencimiento , causará interés moratorio al 3% por ciento mensual, nos reservamos el derecho de cobrar el 20% sobre el importe por cheques devueltos.</p>
                                            <br />
                                            <br />
                                            <br />
                                            {InfoByFolio.paidOut == 'N' &&
                                                <br />
                                            }
                                            <table>
                                                <tbody>
                                                    {InfoByFolio.paidOut == 'Y' &&
                                                        <tr>
                                                            <td></td>
                                                            <td></td>
                                                            <td className="text-right">
                                                                <img src={require('../../images/sello.png')} alt="Sello" style={{width:"275px"}}/>
                                                            </td>
                                                        </tr>
                                                    }
                                                    <tr>
                                                        <td className="text-center" colspan="3">__________________________________________________________</td>
                                                    </tr>
                                                    <tr>
                                                        <td className="text-center" colspan="3">ACEPTO</td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </td></tr></table>
                    </>
                }
            </>
        )
    }
}

export default DeliveryHouse